import styled from 'styled-components'


export const ErrorDiv = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background-color: #0d039c;
min-height:100vh;
p{
    text-decoration:none;
    color:white;
}


`